import { PlatformAppsApiClient } from '@fourthwall/services/dist/PlatformAppsApiClient'
import { useMutation } from '@tanstack/react-query'

export const useDisconnectPlatformAppMutation = (appId: string) => {
  const disconnectPlatformAppMutation = useMutation({
    mutationFn: async () => {
      const { data } = await PlatformAppsApiClient.disconnectPlatformApp({ appId })

      return data
    },
  })

  return { disconnectPlatformAppMutation }
}
